import { createAction } from '@reduxjs/toolkit';
import { MailingSettings } from 'store/interfaces';
import { storeName } from '../config';

export const setMailingSettings = createAction<MailingSettings>(
  `${storeName}/setMailingSettings`,
);
